/* Shipping / delivery / returns strip, directly under Add to Cart.
   The three questions customers were scrolling all the way to the FAQ for.
   Anchors on #cd-err, which is static Liquid markup present at parse time,
   so there is no timing or lookup to get wrong. */
(function(){
var ROWS=[
['M1 3h15v13H1z|M16 8h4l3 3v5h-7z|c:5.5,18.5|c:18.5,18.5','Ships in 1&ndash;2 business days','Straight from our warehouse, tracking emailed the moment it leaves.'],
['M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z|M12 6v6l4 2','Arrives in 5&ndash;8 business days','Rush shipping available at checkout if you need it before the weekend.'],
['M3 12a9 9 0 1 0 3-6.7|M3 4v5h5','30-day no-questions returns','If it doesn&rsquo;t get a laugh, send it back. Wrong size? We swap it free.']
];

function icon(spec){
var parts=spec.split('|'),d='',c='';
for(var i=0;i<parts.length;i++){
if(parts[i].indexOf('c:')===0){var xy=parts[i].slice(2).split(',');c+='<circle cx="'+xy[0]+'" cy="'+xy[1]+'" r="2.2"></circle>';}
else{d+='<path d="'+parts[i]+'"></path>';}
}
return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#b1272f" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0; margin-top:1px;">'+d+c+'</svg>';
}

function build(){
var anchor=document.getElementById('cd-err');
if(!anchor||document.getElementById('cd-trust'))return;
var box=document.createElement('div');
box.id='cd-trust';
box.setAttribute('style','margin-top:16px; background:#fff; border:1px solid #e5e0d3; border-radius:14px; padding:6px 14px;');
var html='';
for(var i=0;i<ROWS.length;i++){
html+='<div style="display:flex; gap:11px; align-items:flex-start; padding:11px 0;'+(i<ROWS.length-1?' border-bottom:1px solid #f1ede2;':'')+'">'+
icon(ROWS[i][0])+
'<div><div style="font-weight:800; font-size:13.5px; color:#0d2340; line-height:1.35;">'+ROWS[i][1]+'</div>'+
'<div style="font-size:12.5px; color:#6b7385; line-height:1.45; margin-top:1px;">'+ROWS[i][2]+'</div></div></div>';
}
box.innerHTML=html;
anchor.parentNode.insertBefore(box,anchor.nextSibling);
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',build);}else{build();}
setTimeout(build,300);
})();
